import React, { useEffect, useState } from 'react';
import { Widget, MasterDetailForm, Button, FormSubmitButton, FormatText, ColumnProps, FormSelect, notification } from '@digital/ui';
import { Projeto } from '@app/api/projeto';
import { PaginationConfig } from 'antd/lib/pagination';
import UploadFileDefault from '@app/components/uploadFileDefault';
import { compareText } from '@app/helpers/comparators';
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';
import { formatCurrencyBr, formatCurrencyBrReturnNull } from '@app/helpers/numbers';
import { useRecoilState, useRecoilValue } from 'recoil';
import { aDistribuirProjetoResult, listCrfTipoDistribuicaoForcast } from '@app/state/atom';
import {
    adcionarMesAno,
    ADistribuirViewResult,
    AlteracaoEsin204,
    atualizarLinhaCrfConsolidadoPluriAnual,
    ExecutadoMesAnoADistribuir,
    FormCrfConsolidadoPluriAnualById,
    FormDataInicialFinal,
    FormUpdateTipoDistribuicao,
    getADistribuirByCrfProjetoId,
    GetCrfConsolidadoPluriAnualByIdCommandResult,
    getFileADistribuirByCrfProjetoId,
    MesAnoADistribuir,
    PrimeiroNivel,
    ResultadoADistribuirPluriAnual,
    SegundoNivel,
    TerceiroNivel,
    updateADistribuirMesAno,
    updateADistribuirTipoDistribuicao,
    updatePeriodoDataInicialOuDateFinal
} from '@app/api/crf/crfADistribuir';
import { Table, DatePicker } from 'antd';
import CurrencyInput from '@app/components/CurrencyInput';
import { newGuid } from '@app/helpers/generatorGuid';
import moment from 'moment';
import ProgressBarADistribuir from './ProgressBarADistribuir';
import ModalProcessoAtualizacaoADistribuir from './ModalProcessoAtualizacaoADistribuir';

const { MonthPicker } = DatePicker;

const enderecoPostFileImportADistribuir = 'crfADistribuir/importarPlanilhaCrfADistrubuir';

interface PropFormAContratar {
    selectedItem: Projeto;
    hasGetADistribuirByCrfProjetoId: (crfProjetoId: string, consultaRelatorio: boolean) => any;
    larguraTabela: number
}


const FormADistribuir = (props: PropFormAContratar) => {

    const { selectedItem, hasGetADistribuirByCrfProjetoId, larguraTabela } = props;
    const larguraPadrao = 200;
    const larguraNome = 400;
    const [aDistribuirViewModelResult, setADistribuirViewModelResult] = useRecoilState(aDistribuirProjetoResult);
    const [novoValorADistribuirMesAno, setNovoValorADistribuirMesAno] = useState<number>()
    const listTipoDistribuicaoForcast = useRecoilValue(listCrfTipoDistribuicaoForcast);


    useEffect(() => {
        if (selectedItem) {
            setADistribuirViewModelResult({});
            hasGetADistribuirByCrfProjetoId(selectedItem.id, true);
        }
    }, [selectedItem]);

    const formatformatCurrencyBrReturnNullADistribuir = (numeroNivel: number, valor?: number): string => {
        if (numeroNivel === 1) {
            if (valor == undefined)
                valor = 0;
            return formatCurrencyBrReturnNull(valor)
        }
        if (valor)
            return formatCurrencyBrReturnNull(valor)
        return '';
    }

    const formatCurrencyBrReturnNullAContratar = (valor?: number): string => {
        if (valor == undefined)
            valor = 0;
        return formatCurrencyBrReturnNull(valor);
    }

    const getColorADistribuir = (numeroNivel: number, valor?: number) => {

        if (valor == undefined)
            return '';

        if (numeroNivel === 1 || numeroNivel == 3) {
            if (valor >= 0) {
                return 'blue'
            } else {
                return 'red'
            }
        }
        return '';
    }



    const collunsADistribuir = () => {

        let colluns: ColumnProps<any>[] = [
            {
                title: 'N',
                dataIndex: 'numeroLinha',
                width: larguraPadrao,
                fixed: 'left'
            },
            {
                title: 'CÓDIGO',
                dataIndex: 'codigoPacote',
                width: larguraPadrao,
                sorter: (a, b) => compareText(a.codigoPacote, b.codigoPacote),
                ...mountFormFilterDropDown('codigoPacote', 'Pesquisar'),
                fixed: 'left'

            },
            {
                title: 'NOME',
                dataIndex: 'nome',
                width: larguraNome,
                sorter: (a, b) => compareText(a.nome, b.nome),
                ...mountFormFilterDropDown('nome', 'Pesquisar'),
                fixed: 'left'
            },
            {
                title: `${formatCurrencyBr(aDistribuirViewModelResult.totalOrcado)}`,
                align: 'center',
                width: larguraPadrao,
                children: [
                    {
                        title: 'A',
                        align: 'center',
                        children: [
                            {
                                title: 'ORÇADO',
                                align: 'center',
                                render: (text: any, record: ResultadoADistribuirPluriAnual, index: number) => {
                                    if (record.numeroNivel === 2)
                                        return [];

                                    if (record.numeroNivel === 1) {
                                        return [<>{formatformatCurrencyBrReturnNullADistribuir(record.numeroNivel, record.orcado)}</>]
                                    } else {
                                        if (record.tipoConsolidadoPlurianualCodigo === 1
                                            || record.tipoConsolidadoPlurianualCodigo === 2
                                            || record.tipoConsolidadoPlurianualCodigo === 3) {
                                            return [<>{formatCurrencyBrReturnNullAContratar(record.orcado)}</>]
                                        } else {
                                            if (record.tipoConsolidadoPlurianualCodigo != 4 && record.tipoConsolidadoPlurianualCodigo != 5)
                                                return formatCurrencyBrReturnNull(record.orcado);
                                        }
                                    }

                                    return [];
                                }
                            }]
                    },
                ]
            },
            {
                title: `${formatCurrencyBr(aDistribuirViewModelResult.totalContratado)}`,
                align: 'center',
                width: larguraPadrao,
                children: [
                    {
                        title: 'B',
                        align: 'center',
                        children: [
                            {
                                title: 'CONTRATADO',
                                align: 'center',
                                render: (text: any, record: ResultadoADistribuirPluriAnual, index: number) => {
                                    if (record.numeroNivel === 2)
                                        return [];


                                    if (record.numeroNivel === 3) {
                                        if (record.tipoConsolidadoPlurianualCodigo != 4 && record.tipoConsolidadoPlurianualCodigo != 5)
                                            return formatCurrencyBrReturnNull(record.contratado);
                                    }

                                    return [<div >{formatformatCurrencyBrReturnNullADistribuir(record.numeroNivel, record.contratado)}</div>]
                                }
                            }]
                    },
                ]
            },
            {
                title: `${formatCurrencyBr(aDistribuirViewModelResult.totalExecutado)}`,
                align: 'center',
                width: larguraPadrao,
                children: [
                    {
                        title: 'C',
                        align: 'center',
                        children: [
                            {
                                title: 'EXECUTADO',
                                align: 'center',
                                render: (text: any, record: ResultadoADistribuirPluriAnual, index: number) => {

                                    if (record.numeroNivel === 3) {
                                        if (record.tipoConsolidadoPlurianualCodigo != 4 && record.tipoConsolidadoPlurianualCodigo != 5)
                                            return formatCurrencyBrReturnNull(record.executado);
                                    }

                                    return [<>{formatformatCurrencyBrReturnNullADistribuir(record.numeroNivel, record.executado)}</>]
                                }
                            }]
                    },
                ]
            },
            {
                title: `${formatCurrencyBr(aDistribuirViewModelResult.totalRequisitado)}`,
                align: 'center',
                width: larguraPadrao,
                children: [
                    {
                        title: 'D',
                        align: 'center',
                        children: [
                            {
                                title: 'requisitado',
                                align: 'center',
                                render: (text: any, record: ResultadoADistribuirPluriAnual, index: number) => {
                                    if (record.numeroNivel === 2)
                                        return [];

                                    if (record.numeroNivel === 1) {
                                        return [<>{formatformatCurrencyBrReturnNullADistribuir(record.numeroNivel, record.requisitado)}</>]
                                    } else {
                                        if (record.tipoConsolidadoPlurianualCodigo === 5) {
                                            return [<>{formatCurrencyBrReturnNullAContratar(record.requisitado)}</>]
                                        } else {
                                            if (record.numeroNivel === 3) {
                                                if (record.tipoConsolidadoPlurianualCodigo != 4 && record.tipoConsolidadoPlurianualCodigo != 5)
                                                    return formatCurrencyBrReturnNull(record.requisitado);
                                            }
                                        }
                                    }

                                    return [];
                                }
                            }]
                    },
                ]
            },
            {
                title: `${formatCurrencyBr(aDistribuirViewModelResult.totalCompromissado)}`,
                align: 'center',
                width: larguraPadrao,
                children: [
                    {
                        title: 'E = B - C + D',
                        align: 'center',
                        children: [
                            {
                                title: 'COMPROMISSADO',
                                align: 'center',
                                render: (text: any, record: ResultadoADistribuirPluriAnual, index: number) => {
                                    if (record.numeroNivel === 3) {
                                        if (record.tipoConsolidadoPlurianualCodigo != 4)
                                            return formatCurrencyBrReturnNull(record.compromissado);
                                    }
                                    return [<>{formatformatCurrencyBrReturnNullADistribuir(record.numeroNivel, record.compromissado)}</>]
                                }
                            }]
                    },
                ]
            },
            {
                title: `${formatCurrencyBr(aDistribuirViewModelResult.totalAContratar)}`,
                align: 'center',
                children: [
                    {
                        title: 'F',
                        align: 'center',
                        children: [
                            {
                                title: 'A CONTRATAR',
                                align: 'center',
                                render: (text: any, record: ResultadoADistribuirPluriAnual, index: number) => {
                                    if (record.numeroNivel === 1)
                                        return [<>{formatformatCurrencyBrReturnNullADistribuir(record.numeroNivel, record.aContratar)}</>]


                                    if (record.numeroNivel === 3) {
                                        if (record.tipoConsolidadoPlurianualCodigo == 4)
                                            return formatCurrencyBrReturnNull(record.aContratar);
                                    }
                                    return [];
                                }
                            }]
                    },
                ]
            },
            {
                title: `${formatCurrencyBr(aDistribuirViewModelResult.totalForecast)}`,
                align: 'center',
                width: larguraPadrao,
                children: [
                    {
                        title: 'G = B + D + F',
                        align: 'center',
                        children: [
                            {
                                title: 'FORECAST',
                                align: 'center',
                                render: (text: any, record: ResultadoADistribuirPluriAnual, index: number) => {
                                    if (record.numeroNivel === 3)
                                        return formatCurrencyBrReturnNull(record.forcast);

                                    return [<>{formatformatCurrencyBrReturnNullADistribuir(record.numeroNivel, record.forcast)}</>]
                                }
                            }]
                    },
                ]
            },
            {
                title: `${formatCurrencyBr(aDistribuirViewModelResult.totalSaldo)}`,
                align: 'center',
                width: larguraPadrao,
                children: [
                    {
                        title: 'H = A - G',
                        align: 'center',
                        children: [
                            {
                                title: 'SALDO',
                                align: 'center',
                                render: (text: any, record: ResultadoADistribuirPluriAnual, index: number) => {
                                    if (record.numeroNivel === 3)
                                        return formatCurrencyBrReturnNull(record.saldo);

                                    return [<>{formatformatCurrencyBrReturnNullADistribuir(record.numeroNivel, record.saldo)}</>]
                                }
                            }]
                    },
                ]
            },
            {
                title: `${formatCurrencyBr(aDistribuirViewModelResult.totalADistribuir)}`,
                align: 'center',
                width: larguraPadrao,
                children: [
                    {
                        title: 'I = G - C',
                        align: 'center',
                        children: [
                            {
                                title: 'A DISTRIBUIR',
                                align: 'center',
                                render: (text: any, record: ResultadoADistribuirPluriAnual, index: number) => {
                                    if (record.numeroNivel === 3) {
                                        if (record.tipoConsolidadoPlurianualCodigo != 1
                                            && record.tipoConsolidadoPlurianualCodigo != 2
                                            && record.tipoConsolidadoPlurianualCodigo != 3) {
                                            return [<div style={{ color: getColorADistribuir(record.numeroNivel, record.aDistribuir) }}>{formatCurrencyBrReturnNull(record.aDistribuir)}</div>]
                                            //return formatCurrencyBrReturnNull(record.saldo);
                                        }
                                    }
                                    return [<div style={{ color: getColorADistribuir(record.numeroNivel, record.aDistribuir) }}>{formatformatCurrencyBrReturnNullADistribuir(record.numeroNivel, record.aDistribuir)}</div>]
                                }
                            }]
                    },
                ]
            },
            {
                title: `${formatCurrencyBr(aDistribuirViewModelResult.totalVerficacaoPluriAnual)}`,
                align: 'center',
                width: larguraPadrao,
                children: [
                    {
                        title: 'VERIFICAÇÃO PLURIANUAL',
                        align: 'center',
                        render: (text: any, record: ResultadoADistribuirPluriAnual, index: number) => {
                            if (record.numeroNivel === 1 || record.numeroNivel === 3) {
                                if (record.tipoConsolidadoPlurianualCodigo != 1 &&
                                    record.tipoConsolidadoPlurianualCodigo != 2 &&
                                    record.tipoConsolidadoPlurianualCodigo != 3) {
                                    return [<>{formatCurrencyBrReturnNull(record.verificacaoPlurianual)}</>]
                                }
                            }
                            return [];
                        }
                    },
                ]
            },
            {
                title: `${formatCurrencyBr(aDistribuirViewModelResult.totalExecutadoAnosAnteriores)}`,
                align: 'center',
                width: larguraPadrao,
                children: [
                    {
                        title: 'EXECUTADO NOS ANOS ANTERIORES',
                        align: 'center',
                        render: (text: any, record: ResultadoADistribuirPluriAnual, index: number) => {

                            if (record.numeroNivel === 1 || record.numeroNivel === 3) {

                                if (record.tipoConsolidadoPlurianualCodigo != 1 &&
                                    record.tipoConsolidadoPlurianualCodigo != 2 &&
                                    record.tipoConsolidadoPlurianualCodigo != 3 &&
                                    record.tipoConsolidadoPlurianualCodigo != 4 &&
                                    record.tipoConsolidadoPlurianualCodigo != 5) {


                                    return [<>{formatCurrencyBrReturnNull(record.executadoAnosAnterios)}</>]
                                }
                            }

                            return [];
                            // return [<>{formatformatCurrencyBrReturnNullADistribuir(record.numeroNivel, record.executadoAnosAnterios)}</>]
                        }
                    },
                ]
            },
        ];




        if (aDistribuirViewModelResult && aDistribuirViewModelResult.colunasExecutadoMesAno) {
            aDistribuirViewModelResult.colunasExecutadoMesAno.map((colunaExecutado) => {

                colluns.push(
                    {
                        title: `${formatCurrencyBr(colunaExecutado.totalColuna)}`,
                        align: 'center',
                        width: larguraPadrao,
                        children: [
                            {
                                title: 'EXECUTADO',
                                align: 'center',
                                children: [
                                    {
                                        title: `${colunaExecutado.descricao}`,
                                        align: 'center',
                                        render: (text: any, record: any, index: number) => {
                                            if (record.numeroNivel === 1) {
                                                if (record.colunasExecutadoMesAno) {
                                                    const resultPrimeiroNivel = record as PrimeiroNivel;

                                                    if (resultPrimeiroNivel.colunasExecutadoMesAno
                                                        && resultPrimeiroNivel.colunasExecutadoMesAno.length) {
                                                        const executadoPrimeiroNivelResult = resultPrimeiroNivel
                                                            .colunasExecutadoMesAno
                                                            .filter(c => c.key === colunaExecutado.key);

                                                        if (executadoPrimeiroNivelResult) {
                                                            return [<>{formatformatCurrencyBrReturnNullADistribuir(record.numeroNivel, executadoPrimeiroNivelResult[0].totalColuna)}</>]
                                                        }
                                                    }
                                                    return [<></>]
                                                }
                                            }

                                            if (record.numeroNivel === 3) {
                                                if (record.tipoConsolidadoPlurianualCodigo != 1 &&
                                                    record.tipoConsolidadoPlurianualCodigo != 2 &&
                                                    record.tipoConsolidadoPlurianualCodigo != 3 &&
                                                    record.tipoConsolidadoPlurianualCodigo != 4 &&
                                                    record.tipoConsolidadoPlurianualCodigo != 5) {

                                                    const valorExecutado = record[`${colunaExecutado.key}`]
                                                    return [<>{formatCurrencyBrReturnNull(valorExecutado)}</>]
                                                }
                                            }
                                            return [];
                                        }
                                    }]
                            },
                        ]

                    })
            })
        }


        colluns.push(
            {
                title: `DISTRIBUIÇÃO`,
                align: 'center',
                width: larguraPadrao,
                children: [
                    {
                        title: 'TIPO DE DISTRIBUIÇÃO',
                        align: 'center',
                        render: (text: any, record: ResultadoADistribuirPluriAnual, index: number) => {
                            return getImputTipoDistribuicao(record);
                        }
                    },
                    {
                        title: 'PERÍODO INICIO / PERÍODO FIM',
                        align: 'center',
                        render: (text: any, record: ResultadoADistribuirPluriAnual, index: number) => {
                            if (record.numeroNivel === 1 || record.numeroNivel === 2) {
                                return [];
                            }
                            return getImputPeriodo(record);
                        }
                    },

                ]
            },
        )



        if (aDistribuirViewModelResult && aDistribuirViewModelResult.colunasADistribuir) {
            aDistribuirViewModelResult.colunasADistribuir.map((colunaADistribuir) => {

                colluns.push(
                    {
                        title: `${formatCurrencyBr(colunaADistribuir.totalColuna)}`,
                        align: 'center',
                        children: [
                            {
                                title: 'A DISTRIBUIR',
                                align: 'center',
                                width: larguraPadrao,
                                children: [
                                    {
                                        title: `${colunaADistribuir.descricao}`,
                                        align: 'center',
                                        render: (text: any, record: any, index: number) => {
                                            if (record.numeroNivel === 2)
                                                return [];

                                            if (record.numeroNivel === 1) {
                                                if (record.colunasADistribuir) {
                                                    const valorADistribuir = record[`${colunaADistribuir.key}`]
                                                    return [<>{formatformatCurrencyBrReturnNullADistribuir(record.numeroNivel, valorADistribuir)}</>]
                                                }
                                            }

                                            return hasConstruirImpurtADistribuir(record, colunaADistribuir);
                                        }
                                    }]
                            },
                        ]

                    })
            })
        }


        return colluns;
    }

    const hasConstruirImpurtADistribuir = (record: any, colunaADistribuir: ExecutadoMesAnoADistribuir) => {
        if (record.numeroNivel === 1) {
            const valorADistribuir = record[`${colunaADistribuir.key}`]
            return [<>{formatformatCurrencyBrReturnNullADistribuir(record.numeroNivel, valorADistribuir)}</>]
        } else {
            if (record.numeroNivel === 3) {

                const valorADistribuir = record[`${colunaADistribuir.key}`]

                const codigoTipoConsolidado = record.tipoConsolidadoPlurianualCodigo;
                const terceiroNivel = record as TerceiroNivel;

                if (record.crfTipoDistribuicaoForcastCodigo != 1) {
                    return [<>{formatCurrencyBrReturnNull(valorADistribuir)}</>]
                }



                switch (codigoTipoConsolidado) {
                    case AlteracaoEsin204.AContratar: {
                        return hasImputCurrent(valorADistribuir, terceiroNivel, colunaADistribuir);
                    }
                    case AlteracaoEsin204.Requisitado: {
                        return hasImputCurrent(valorADistribuir, terceiroNivel, colunaADistribuir);
                    }
                    case AlteracaoEsin204.FornecedorPcm: {
                        return hasImputCurrent(valorADistribuir, terceiroNivel, colunaADistribuir);
                    }
                    case AlteracaoEsin204.FornecedorCt: {
                        return hasImputCurrent(valorADistribuir, terceiroNivel, colunaADistribuir);
                    }
                    case AlteracaoEsin204.FornecedorPcs: {
                        return hasImputCurrent(valorADistribuir, terceiroNivel, colunaADistribuir);
                    }
                    case AlteracaoEsin204.MRNCombustivel: {
                        return hasImputCurrent(valorADistribuir, terceiroNivel, colunaADistribuir);
                    }
                    case AlteracaoEsin204.MRNViagens: {
                        return hasImputCurrent(valorADistribuir, terceiroNivel, colunaADistribuir);
                    }
                    case AlteracaoEsin204.MRNDiversos: {
                        return hasImputCurrent(valorADistribuir, terceiroNivel, colunaADistribuir);
                    }
                    case AlteracaoEsin204.MRNOverhead: {
                        return hasImputCurrent(valorADistribuir, terceiroNivel, colunaADistribuir);
                    }
                    default: {
                        return [];
                    }
                }

            }
        }
        return [];
    }

    const hasImputCurrent = (valor: number, record: TerceiroNivel, coluna: ExecutadoMesAnoADistribuir) => {
        return [
            <CurrencyInput
                id={newGuid()}
                name={newGuid()}
                value={valor}
                defaultValue={valor}
                onChange={e => {
                    setNovoValorADistribuirMesAno(e);
                }}
                onKeyDown={e => {
                    if (e.key === 'Enter') {
                        const mesAnoValorADistribuir = {
                            colunaId: coluna.dataMesAno,
                            crfConsolidadoPluriAnualId: record.crfConsolidadoPluriAnualId,
                            tipoConsolidadoPlurianualCodigo: record.tipoConsolidadoPlurianualCodigo,
                            valor: novoValorADistribuirMesAno
                        } as MesAnoADistribuir;

                        updateADistribuirMesAno(mesAnoValorADistribuir)
                            .then(() => {
                                let aDistribuirViewModelNovo = {
                                    ...aDistribuirViewModelResult,
                                    children: aDistribuirViewModelResult
                                        .children
                                        .map((itemNivel1a) => {
                                            return {
                                                ...itemNivel1a,
                                                children: itemNivel1a
                                                    .children
                                                    .map((itemNivel2a) => {
                                                        return {
                                                            ...itemNivel2a,
                                                            children: itemNivel2a
                                                                .children
                                                                .map((itemNivel3a) => {
                                                                    if (itemNivel3a.key === record.key) {
                                                                        let novoItem = { ...itemNivel3a };
                                                                        novoItem[`${coluna.key}`] = mesAnoValorADistribuir.valor;
                                                                        return novoItem;
                                                                    } else {
                                                                        return itemNivel3a;
                                                                    }
                                                                })
                                                        }
                                                    })
                                            }
                                        })
                                }
                                setADistribuirViewModelResult(aDistribuirViewModelNovo);
                            })
                    }
                }}
            />]
    }



    const getImputTipoDistribuicao = (record: any) => {
        if (record.numeroNivel === 1 || record.numeroNivel === 2) {
            return [<></>]
        } else {
            if (record.numeroNivel === 3) {


                const codigoTipoConsolidado = record.tipoConsolidadoPlurianualCodigo;
                const crfTipoDistribuicaoForcastId = record.crfTipoDistribuicaoForcastId;

                switch (codigoTipoConsolidado) {
                    case AlteracaoEsin204.AContratar: {
                        return hasImputTipoDistribuircao(crfTipoDistribuicaoForcastId, record);
                    }
                    case AlteracaoEsin204.Requisitado: {
                        return hasImputTipoDistribuircao(crfTipoDistribuicaoForcastId, record);
                    }
                    case AlteracaoEsin204.FornecedorPcm: {
                        return hasImputTipoDistribuircao(crfTipoDistribuicaoForcastId, record);
                    }
                    case AlteracaoEsin204.FornecedorCt: {
                        return hasImputTipoDistribuircao(crfTipoDistribuicaoForcastId, record);
                    }
                    case AlteracaoEsin204.FornecedorPcs: {
                        return hasImputTipoDistribuircao(crfTipoDistribuicaoForcastId, record);
                    }
                    case AlteracaoEsin204.MRNCombustivel: {
                        return hasImputTipoDistribuircao(crfTipoDistribuicaoForcastId, record);
                    }
                    case AlteracaoEsin204.MRNViagens: {
                        return hasImputTipoDistribuircao(crfTipoDistribuicaoForcastId, record);
                    }
                    case AlteracaoEsin204.MRNDiversos: {
                        return hasImputTipoDistribuircao(crfTipoDistribuicaoForcastId, record);
                    }
                    case AlteracaoEsin204.MRNOverhead: {
                        return hasImputTipoDistribuircao(crfTipoDistribuicaoForcastId, record);
                    }
                    default: {
                        return [];
                    }
                }

            }
        }
        return [];
    }

    const getImputPeriodo = (record: any) => {

        if (record.numeroNivel === 1) {
            return [<></>]
        } else {
            if (record.numeroNivel === 3) {


                const codigoTipoConsolidado = record.tipoConsolidadoPlurianualCodigo;
                const crfTipoDistribuicaoForcastCodigo = record.crfTipoDistribuicaoForcastCodigo;

                switch (codigoTipoConsolidado) {
                    case AlteracaoEsin204.OrcadoCapex: {
                        return [];
                    }
                    case AlteracaoEsin204.OrcadoRfa: {
                        return [];
                    }
                    case AlteracaoEsin204.OrcadoAnual: {
                        return [];
                    }
                }

                if (crfTipoDistribuicaoForcastCodigo != undefined) {
                    if (crfTipoDistribuicaoForcastCodigo === 1) {
                        // const dataReferenciaFormatadaInicio = record.periodoInicioFormatado ? record.periodoInicioFormatado : '';
                        // const dataReferenciaFormatadaFim = record.periodoFimFormatado ? record.periodoFimFormatado : '';
                        // return [<>{dataReferenciaFormatadaInicio} até {dataReferenciaFormatadaFim}</>]
                        return [<></>]
                    } else {
                        switch (codigoTipoConsolidado) {
                            case AlteracaoEsin204.AContratar: {
                                return hasImputData(record);
                            }
                            case AlteracaoEsin204.Requisitado: {
                                return hasImputData(record);
                            }
                            case AlteracaoEsin204.FornecedorPcm: {
                                return hasImputData(record);
                            }
                            case AlteracaoEsin204.FornecedorCt: {
                                return hasImputData(record);
                            }
                            case AlteracaoEsin204.FornecedorPcs: {
                                return hasImputData(record);
                            }
                            case AlteracaoEsin204.MRNCombustivel: {
                                return hasImputData(record);
                            }
                            case AlteracaoEsin204.MRNViagens: {
                                return hasImputData(record);
                            }
                            case AlteracaoEsin204.MRNDiversos: {
                                return hasImputData(record);
                            }
                            case AlteracaoEsin204.MRNOverhead: {
                                return hasImputData(record);
                            }
                            default: {
                                return [];
                            }
                        }
                    }
                }
            }
        }
        return [];

    }

    const hasImputData = (record: TerceiroNivel) => {
        return [
            <>
                <MonthPicker
                    name={`dataInicio_${record.key}`}
                    defaultValue={record.periodoInicio ? moment(record.periodoInicio) : undefined}
                    onChange={(e) => {
                        const dataInicialAlteracao = { dataRefencia: moment(e).toDate(), crfConsolidadoPluriAnualId: record.crfConsolidadoPluriAnualId, ehDataInicial: true } as FormDataInicialFinal;


                        updatePeriodoDataInicialOuDateFinal(dataInicialAlteracao)
                            .then(() => {
                                atualizarLinhaADistribuir(record);
                            });
                    }}
                    placeholder="Selecione Mês/Ano"
                />
                <>  até  </>
                <MonthPicker
                    name={`dataFinal_${record.key}`}
                    defaultValue={record.periodoFim ? moment(record.periodoFim) : undefined}
                    onChange={(e) => {
                        const dataFinalAlteracao = {
                            dataRefencia: moment(e).toDate(),
                            crfConsolidadoPluriAnualId: record.crfConsolidadoPluriAnualId, ehDataInicial: false
                        } as FormDataInicialFinal;



                        updatePeriodoDataInicialOuDateFinal(dataFinalAlteracao)
                            .then(() => {
                                atualizarLinhaADistribuir(record);
                            });
                    }}
                    placeholder="Selecione Mês/Ano"
                />
            </>
        ]
    }

    const hasImputTipoDistribuircao = (tipoDistribuicaoForcastId: string, record: TerceiroNivel) => {
        return [
            <FormSelect
                name={newGuid()}
                placeholder="Selecione uma opção"
                value={tipoDistribuicaoForcastId}
                options={listTipoDistribuicaoForcast}
                onChange={(e) => {

                    const alteracaoTipoDistribuircao = {
                        tipoDistribuicaoForcastId: e,
                        crfConsolidadoPluriAnualId: record.crfConsolidadoPluriAnualId
                    } as FormUpdateTipoDistribuicao

                    updateADistribuirTipoDistribuicao(alteracaoTipoDistribuircao)
                        .then(() => {
                            atualizarLinhaADistribuir(record);
                        })
                }}
            />
        ]
    }

    const atualizarLinhaADistribuir = (record: TerceiroNivel) => {
        atualizarLinhaCrfConsolidadoPluriAnual({
            crfConsolidadoPlurianualId: record.crfConsolidadoPluriAnualId,
            primeiroNivel: record.keyNivel1,
            segundoNivel: record.keyNivel2,
            key: record.key,
            indexCc: record.codigoPacote
        } as FormCrfConsolidadoPluriAnualById).then((data) => {
            const novoValor = data as GetCrfConsolidadoPluriAnualByIdCommandResult;
            let aDistribuirViewModelNovo = {
                ...aDistribuirViewModelResult,
                children: aDistribuirViewModelResult
                    .children
                    .map((itemNivel1a) => {
                        return {
                            ...itemNivel1a,
                            children: itemNivel1a
                                .children
                                .map((itemNivel2a) => {
                                    return {
                                        ...itemNivel2a,
                                        children: itemNivel2a
                                            .children
                                            .map((itemNivel3a) => {
                                                if (itemNivel3a.key === record.key) {
                                                    return novoValor.crfConsolidadoPlurianual
                                                } else {
                                                    return itemNivel3a;
                                                }
                                            })
                                    }
                                })
                        }
                    })
            }
            setADistribuirViewModelResult(aDistribuirViewModelNovo);
        })
    }

    const hasAdcionarMesAno = () => {
        adcionarMesAno(selectedItem.id)
            .then((data) => {
                notification.success(`Ano/mês adicionado com sucesso!`);
                window.location.reload();
            })
    }

    const hasExportarADistribuir = () => {
        const nome = selectedItem.codigo + '_'+ selectedItem.nome
        getFileADistribuirByCrfProjetoId(selectedItem.id, nome);
    }

    return (<>


        <MasterDetailForm>
            <Widget
                title={'A CONTRATAR PLURIANUAL'}
                actions={[

                    <Button
                        type="primary"
                        name="btnAtualizarTabela"
                        icon="ui-available_updates"
                        onClick={() => {
                            hasGetADistribuirByCrfProjetoId(selectedItem.id, false);
                        }}>
                        <FormatText id="ui.commons.save" uppercase transform={() => "ATUALIZAR ADISTRIBUIR"} />
                    </Button>,
                    <Button
                        type="link"
                        name="btnExportar"
                        icon="data-export"
                        onClick={() => {
                            hasExportarADistribuir();
                        }}>
                        <FormatText id="data-export" uppercase transform={() => "Exportar"} />
                    </Button>,
                    <UploadFileDefault
                        descricaoBotao="Importar ADistribuir"
                        id={selectedItem && selectedItem.id}
                        idDoComponente={'btnImportFilePlanilha'}
                        enderecoApi={enderecoPostFileImportADistribuir}
                        nomeIdFormulario={'CrfProjetoId'}
                        retorno={() => {
                            hasGetADistribuirByCrfProjetoId(selectedItem.id, false);
                        }}
                    />,
                    <ModalProcessoAtualizacaoADistribuir />,
                    <FormSubmitButton
                        type="primary"
                        onClick={() => {
                            hasAdcionarMesAno();
                        }}>
                        <FormatText id="ui.commons.save" uppercase transform={() => "ADICIONAR ANO"} />
                    </FormSubmitButton>,
                ]}>
                <div>

                    <Table
                        columns={collunsADistribuir()}
                        key={'key'}
                        id={'tableADistribuirCrf'}
                        dataSource={aDistribuirViewModelResult ? aDistribuirViewModelResult.children : []}
                        scroll={{ x: larguraTabela }}
                        pagination={{
                            onChange: (() => {
                                document.getElementById("tableADistribuirCrf").scrollIntoView();
                            })
                        } as PaginationConfig}

                    />

                    <ProgressBarADistribuir />
                </div>
            </Widget>
        </MasterDetailForm>
    </>);
}

export default FormADistribuir;

